// slide09
var slide09 = new Swiper(".slide09", {
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    navigation: {
        nextEl: '.slide09 .swiper-button-next',
        prevEl: '.slide09 .swiper-button-prev',
    },
    pagination: {
        el: ".slide09 .swiper-pagination",
        type: 'bullets',
        clickable: true,
    },
});